export default function getColorWithAlpha(color, alpha) {
  if (!color) return "transparent";
  color = color.trim();
  if (color.startsWith("#")) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((char) => char + char)
        .join("");
    }
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  if (color.startsWith("rgb")) {
    const match = color.match(/\d+\.?\d*/g);
    if (match && match.length >= 3) {
      return `rgba(${match[0]}, ${match[1]}, ${match[2]}, ${alpha})`;
    }
  }

  // Handle hsl/hsla
  if (color.startsWith("hsl")) {
    const match = color.match(/\d+\.?\d*/g);
    if (match && match.length >= 3) {
      return `hsla(${match[0]}, ${match[1]}%, ${match[2]}%, ${alpha})`;
    }
  }

  return color;
}
